import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Suspense, createContext, lazy } from "react";
const initialState = {
    skin: "default"
};
export const SkinContext = createContext(initialState);
/**
 * Skins are loaded lazily, one webpack chunk per skin. This is not just a
 * size optimisation: a skin's module also pulls in its own `styles/styles.css`,
 * and a static import would put that stylesheet in the main widget bundle —
 * so it would style the widget even when the skin isn't the active one.
 * Only reference a skin's folder through this registry.
 */
const skinComponents = {
    wideWithSummary: lazy(() => import(
    /* webpackChunkName: "skin-wide-with-summary" */
    '../layouts/skins/wideWithSummary/Widget').then((m) => ({ default: m.Widget })))
};
/** Every registered skin, for tooling that has to offer a choice (the design harness). */
export const skinNames = Object.keys(skinComponents);
const SkinProvider = ({ children, skin }) => {
    const value = {
        skin: skin
    };
    const SkinWidget = skin !== "default" ? skinComponents[skin] : null;
    return (_jsxs(SkinContext.Provider, { value: value, children: [SkinWidget && (_jsx(Suspense, { fallback: null, children: _jsx(SkinWidget, {}) })), children] }));
};
export default SkinProvider;
